<template>
  <UiButton
    v-if="visibleActions.length === 1"
    :variant="visibleActions[0].variant || 'secondary'"
    size="sm"
    :icon="visibleActions[0].icon || 'edit'"
    @click="invoke(visibleActions[0])"
  >
    {{ visibleActions[0].label }}
  </UiButton>

  <template v-else-if="visibleActions.length > 1">
    <UiButton variant="ghost" size="sm" icon="menu" class="more-actions-button" @click="open = true">
      Thao tác
    </UiButton>
    <UiModal v-if="open" size="sm" @close="open = false">
      <div class="modal-header mb-4">
        <div>
          <p class="text-lg font-bold text-ink">Thao tác</p>
          <p v-if="title" class="mt-0.5 text-xs text-slate-500">{{ title }}</p>
        </div>
        <UiButton variant="ghost" size="sm" icon="close" @click="open = false">Đóng</UiButton>
      </div>
      <div class="action-dialog-grid">
        <UiButton
          v-for="action in visibleActions"
          :key="action.key || action.label"
          variant="ghost"
          :icon="action.icon || 'edit'"
          :class="['action-dialog__button', { 'action-dialog__button--danger': action.variant === 'danger' }]"
          @click="invoke(action)"
        >
          {{ action.label }}
        </UiButton>
      </div>
    </UiModal>
  </template>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, ref } from "vue";
import UiButton from "@/components/ui/UiButton.vue";
import UiModal from "@/components/ui/UiModal.vue";

type RowAction = {
  key?: string;
  label: string;
  icon?: string;
  variant?: string;
  visible?: boolean;
  run: () => void;
};

export default defineComponent({
  name: "UiRowActions",
  components: { UiButton, UiModal },
  props: {
    actions: { type: Array as PropType<RowAction[]>, default: () => [] },
    title: { type: String, default: "" },
  },
  setup(props) {
    const open = ref(false);
    const visibleActions = computed(() =>
      (props.actions || []).filter((action) => action.visible !== false),
    );
    const invoke = (action: RowAction) => {
      open.value = false;
      action.run();
    };
    return { invoke, open, visibleActions };
  },
});
</script>
